var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-mini-accordion",
      class: [_vm.wrapClass, { "is-open": _vm.status.isOpen }],
    },
    [
      _c(
        "div",
        {
          staticClass: "boss-mini-accordion-head",
          class: _vm.headClass,
          on: { click: _vm.toggle },
        },
        [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "boss-mini-accordion-body" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }